module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_04.4e4a0498.jpg";